/* eslint-disable no-unused-vars */
import { env } from "config/EnvironmentConfig";
import CryptoJS from "crypto-js";
import { msalInstance } from "../../../../../../../config";

const getSpUserEmail = (): string => {
  const authToken = window.localStorage.getItem("auth_token");
  if (authToken) {
    try {
      const parsed = JSON.parse(authToken);
      return parsed.email || "";
    } catch {
      return "";
    }
  }
  const encryptedData = window.localStorage.getItem("userData");
  if (encryptedData) {
    try {
      const SECRET_KEY = "fDrtOnVl3t8OwV+0JjNDsQ==";
      const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
      const user = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      return user?.data?.email || user?.loginUserName || "";
    } catch {
      return "";
    }
  }
  return "";
};

const getMsalUserEmail = (): string => {
  const account =
    msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0];
  return account?.username ?? "";
};

export const defaultConfigApi = {
  getSpUserEmail: (): string => getSpUserEmail() || getMsalUserEmail(),
  domain: env?.baseUrlCAM ?? "",
  xApiKey: "60F5B299-85B6-4EF9-9623-0C29A71DE0B3",
};
